<style scoped lang="less">
</style>

<template>
    <el-dialog :visible.sync="show" title="选择货转方">
        <el-row :gutter="10">
            <el-col :span="12">
                <el-input @input="refetchData" v-model="keyword" placeholder="名称、编号片段搜索" clearable @clear="refetchData"
                    @keyup.native.enter="refetchData"></el-input>
            </el-col>
            <el-col :span="12">
                <el-button type="primary" @click="refetchData">搜索</el-button>
            </el-col>
        </el-row>

        <el-table size="mini" border stripe :data="data" class="block good-result" @row-click="selectRow">
            <el-table-column label="名称" align="center" width="220">
                <template slot-scope="scope">
                    {{scope.row.name}}
                </template>
            </el-table-column>
            <el-table-column label="编号片段" align="center" width="100">
                <template slot-scope="scope">
                    {{scope.row.header}}
                </template>
            </el-table-column>
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <el-button size="mini" type="text" @click="chooseItem(scope.row)">
                        选择
                    </el-button>
                </template>
            </el-table-column>
        </el-table>

        <div class="block">
            <el-pagination layout="prev, pager, next" :total="total" @current-change="changePage"
                :current-page="pageNum+1" :page-size="pageSize">
            </el-pagination>
        </div>
    </el-dialog>
</template>

<script>
import bus from "../../util/bus";
import { HttpClient } from "../../util/http";

export default {
    data() {
        return {
            show: false,
            keyword: "",
            pageSize: 10,
            pageNum: 0,
            data: [],
            total: 0,
            cond: null,
        };
    },
    mixins: [],
    created() {
        bus.on("select-purchaser", async () => {
            this.keyword = "";
            this.data = [];
            this.show = true;
            this.refetchData();
        });
    },
    methods: {
        selectRow(row, event, column) {
            this.chooseItem(row);
        },
        chooseItem(item) {
            this.show = false;
            bus.emit("select-purchaser-result", item);
        },
        refetchData() {
            this.pageNum = 0;
            this.fetchData();
        },
        async fetchData() {
            let cond = {};
            if (this.keyword) {
                const regex = {
                    $regex: this.keyword,
                    $options: "i",
                };
                cond["$or"] = [
                    {
                        name: regex,
                    },
                    {
                        header: regex,
                    },
                ];
            }
            let res = await HttpClient.post("/restful", {
                model: "Purchaser",
                cond,
                // sort: {
                //     _id: -1
                // },
                pageSize: this.pageSize,
                pageNum: this.pageNum,
                withCount: true,
            });
            this.data = res.result;
            this.total = res.count;
        },
        changePage(page) {
            this.pageNum = page - 1;
            this.fetchData();
        },
    },
};
</script>
